import * as THREE from 'three';

export class Cloud {
  static create(): THREE.Group {
    const cloudGroup = new THREE.Group();
    
    const puffs = Math.floor(Math.random() * 3) + 3;
    for (let j = 0; j < puffs; j++) {
      const geometry = new THREE.SphereGeometry(Math.random() * 2 + 1, 16, 16);
      const material = new THREE.MeshPhongMaterial({
        color: 0xffffff,
        transparent: true,
        opacity: 0.8
      });
      const cloudPuff = new THREE.Mesh(geometry, material);
      
      cloudPuff.position.x = j * 2;
      cloudPuff.position.y = Math.random();
      cloudGroup.add(cloudPuff);
    }
    
    return cloudGroup;
  }
}